// Funciones puras de la página común del ítem (bloque 7, B2), sin Supabase.
import { VIGENCIAS_SSO } from './vigencias-sso';

export interface DocumentoItem {
  id: string;
  title: string;
  category: string;
  file_url: string;
  file_name: string;
  file_size_kb: number | null;
  approved_from: string | null;
  expiry_date: string | null;
  created_at: string;
  version: number;
  parent_document_id: string | null;
  is_current: boolean;
}

/** Texto de la vigencia sugerida del ítem (vigencias-sso.ts). */
export function textoVigenciaSugerida(itemId: string): string {
  const r = VIGENCIAS_SSO[itemId];
  if (!r) return 'Este ítem no tiene vigencia sugerida: la fecha "Vigente hasta" es opcional.';
  if ('meses' in r) return `Vigencia sugerida: ${r.meses} ${r.meses === 1 ? 'mes' : 'meses'} desde "Aprobado desde" (${r.cita}). Se llena sola al subir y puedes cambiarla.`;
  return `Vigencia sugerida: hasta el 31 de enero del año siguiente a "Aprobado desde" (${r.cita}). Se llena sola al subir y puedes cambiarla.`;
}

/** Versiones anteriores de un documento vigente (siguiendo parent_document_id), de la más nueva a la más vieja. */
export function versionesAnteriores(doc: DocumentoItem, todos: DocumentoItem[]): DocumentoItem[] {
  const porId = new Map(todos.map(d => [d.id, d]));
  const out: DocumentoItem[] = [];
  let actual = doc.parent_document_id ? porId.get(doc.parent_document_id) : undefined;
  while (actual && !out.includes(actual)) {
    out.push(actual);
    actual = actual.parent_document_id ? porId.get(actual.parent_document_id) : undefined;
  }
  return out;
}

